import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12.8255 4.34297L14.0004 6.69296C14.1588 7.01796 14.5838 7.32629 14.9421 7.39296L17.0671 7.74296C18.4255 7.96796 18.7421 8.95129 17.7671 9.93463L16.1088 11.593C15.8338 11.868 15.6755 12.4096 15.7671 12.8013L16.2421 14.8513C16.6171 16.468 15.7504 17.1013 14.3254 16.2513L12.3338 15.068C11.9754 14.8513 11.3754 14.8513 11.0171 15.068L9.02544 16.2513C7.60044 17.093 6.73378 16.468 7.10878 14.8513L7.58379 12.8013C7.67545 12.418 7.51712 11.8763 7.24212 11.593L5.58379 9.93463C4.60879 8.95963 4.92545 7.97629 6.28379 7.74296L8.40878 7.39296C8.76711 7.33463 9.19211 7.01796 9.35045 6.69296L10.5255 4.34297C11.1505 3.06797 12.1838 3.06797 12.8255 4.34297Z",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M6.66602 4.16797H1.66602",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M4.16602 15.832H1.66602",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M2.49935 10H1.66602",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }